import { render, staticRenderFns } from "./SignUpTabs.vue?vue&type=template&id=5263127e&scoped=true"
import script from "./SignUpTabs.vue?vue&type=script&lang=js"
export * from "./SignUpTabs.vue?vue&type=script&lang=js"
import style0 from "./SignUpTabs.vue?vue&type=style&index=0&id=5263127e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263127e",
  null
  
)

export default component.exports